<template>
    <div style="box-shadow: none; background-color: #fff; border-radius: 8px; border: 1px solid #ddd; min-height: 480px; height: calc(100vh - 190px);">
        <v-container fluid @mouseenter="hover = true" @mouseleave="hover = false"> 
            <v-row>
                <TableWidget ref="tableWidget" :config="config" :context="context" @refresh="$emit('refresh')" @show-alert="$emit('show-alert', $event)" />
            </v-row>
        </v-container>
    </div>
</template>
 
 <script> 
 import BaseModule from '../common/BaseModule.js'
 //import gwt from '../../../api/gwt'
 import TableWidget from './TableWidget'

 export default {
   name: 'WidgetWrapper',
   props: ['config','context'],
   mixins: [BaseModule],
   components: { 
    TableWidget
   },
   
   data() {
       return {
        hover: false,
        moduleLink: {}
       }
   },
    mounted() {
        if (!this.config || !this.config.fields) {
            return;
        }

        this.widgetConfig = JSON.parse(this.config.fields);
        this.moduleLink = this.widgetConfig.moduleLink?this.widgetConfig.moduleLink:{};
        //gwt.showGlobalFilter(!!(this.widgetConfig && this.widgetConfig.showGlobalFilter));
    },
		watch: {
       context: function() { 
        
      },
      config: function(config) { 
        this.widgetConfig = JSON.parse(config.fields);
        this.moduleLink = this.widgetConfig.moduleLink?this.widgetConfig.moduleLink:{};
        //gwt.showGlobalFilter(!!(this.widgetConfig && this.widgetConfig.showGlobalFilter));
    }
     },
    methods: {
        refreshData() {
            this.update();
        },
        update() {
            for (const [key] of Object.entries(this.$refs)) {
                if (this.$refs[key].update) {
                    this.$refs[key].update();
                }
            }
        }
    }
 };
 </script>
  